module.exports = __webpack_public_path__ + "static/media/ilkbahar-Photoroom.b1cc043a.jpg";